var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbtackSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.53125 2.5625-.6875.9375-4.90625 6.6875c-2.628906-.457031-5.410156.285156-7.4375 2.3125l-.71875.6875 5.3125 5.3125-8.09375 8.09375v1.40625h1.40625l8.09375-8.09375 5.3125 5.3125.6875-.71875c2.027344-2.027344 2.769531-4.808594 2.3125-7.4375l6.6875-4.90625.9375-.6875zm.25 3.0625 5.59375 5.59375-6.21875 4.5625-.5625.40625.1875.65625c.480469 1.832031-.042969 3.742188-1.1875 5.34375l-8.78125-8.78125c1.601563-1.144531 3.511719-1.667969 5.34375-1.1875l.65625.1875.40625-.5625z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbtackSolid);
export default __webpack_public_path__ + "static/media/thumbtack-solid.69662f94ef6e8f35066369f07ed465db.svg";
export { ForwardRef as ReactComponent };